import { Formik } from 'formik';
import * as yup from 'yup';
import {TextField, FormControl} from "@mui/material";
import {useTranslation} from "react-i18next";

export const GuestHome = () => {
    const { t } = useTranslation();

    const tEmailKey = t('email');
    const validationSchema = yup.object().shape({
        email: yup
            .string(t('string_required',{field: tEmailKey}))
            .required(t('field_required',{field: tEmailKey}))
            .min(1, t('min_1_chars',{field: tEmailKey}))
            .max(255, t('max_255_chars',{field: tEmailKey})),
    });

    const handleFormSubmit = async (values) => {

    };

    return (
        <div className="fs-page-width">
            <div className="fs-guest-frontpage-container">
                <div className="fs-account-box">
                    <Formik
                        initialValues={{
                            email: '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                        enableReinitialize // Important: allows Formik to update when inputValues changes
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                            <form
                                autoComplete="off"
                                onSubmit={(e) => {
                                e.preventDefault(); // Extra insurance against page reload
                                handleSubmit(e);
                            }}>
                                <FormControl sx={{ width: "100%",marginBottom:'10px' }} fullWidth className="fs-form-control">
                                    <TextField
                                        slotProps={{
                                            htmlInput: { tabIndex: 0 },
                                        }}
                                        className="text-input"
                                        fullWidth
                                        variant="outlined"
                                        label={t("email")}
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder={t("email_placeholder")}
                                        value={values.email}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        error={!!touched.email && !!errors.email}
                                        helperText={touched.email && errors.email}
                                    />
                                </FormControl>
                            </form>
                        )}
                    </Formik>
                </div>
                <div className="fs-right-box">
                    <h1>
                        Velkommen til Swoony
                    </h1>
                    <p className="fs-description">
                        sdf dsf sdfert54 dfg45 rgreg 4 54yt fdgdfg
                    </p>
                </div>
            </div>
        </div>
    );
};